import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MarketPill } from '@market/react';
import { ReactComponent as SquareAppointmentsIcon } from 'images/icons/square-for-appointments.svg';
import { ReactComponent as SquarePointOfSaleIcon } from 'images/icons/square-for-point-of-sale.svg';
import { ReactComponent as SquareResturantsIcon } from 'images/icons/square-for-restaurants.svg';
import { ReactComponent as SquareRetailIcon } from 'images/icons/square-for-retail.svg';

export const COMPATIBLE_SOFTWARE_PILL_ID = 'compatible-software-pill-id';
export const COMPATIBLE_SOFTWARE_SECTION_ID = 'compatible-software-id';

export const ProductCompatibleSoftwareTypes = {
  Restaurants: 'Restaurants',
  Retail: 'Retail',
  Appointments: 'Appointments',
  PointOfSale: 'Point of Sale',
};

const icon = (type) => {
  switch (type) {
    case ProductCompatibleSoftwareTypes.PointOfSale: {
      return <SquarePointOfSaleIcon slot="icon" />;
    }
    case ProductCompatibleSoftwareTypes.Restaurants: {
      return <SquareResturantsIcon slot="icon" />;
    }
    case ProductCompatibleSoftwareTypes.Retail: {
      return <SquareRetailIcon slot="icon" />;
    }
    case ProductCompatibleSoftwareTypes.Appointments: {
      return <SquareAppointmentsIcon slot="icon" />;
    }
    default: {
      return null;
    }
  }
};

const CompatibleSoftwarePill = (props) => {
  const theme = useTheme();

  const { singleSoftware } = props;

  if (!singleSoftware || !singleSoftware.type || !singleSoftware.title) {
    return null;
  }

  return (
    <MarketPill
      data-testid={COMPATIBLE_SOFTWARE_PILL_ID}
      style={{
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
        cursor: 'default',
      }}
      variant="normal"
      size="small"
    >
      {icon(singleSoftware.type)}
      {singleSoftware.title}
    </MarketPill>
  );
};

const ProductCompatibleSoftwareSection = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { software, includes = false } = props;

  if (!software || software.length === 0) return null;

  return (
    <Box
      data-testid={COMPATIBLE_SOFTWARE_SECTION_ID}
      sx={{ display: 'inline', verticalAlign: 'sub' }}
    >
      <Box
        sx={{
          verticalAlign: 'text-top',
          display: 'inline',
          mr: 1,
          fontSize: theme.type.fontSize.tiny,
          color: theme.color.gray['55'],
        }}
      >
        {t(`productPage.${includes ? 'includes' : 'compatibleSoftwareTitle'}`)}
      </Box>
      {software.map((singleSoftware, index) => (
        <CompatibleSoftwarePill key={index} singleSoftware={singleSoftware} />
      ))}
    </Box>
  );
};

export default ProductCompatibleSoftwareSection;
